var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "insights-table" },
    [
      _c("NewSupsisTable", {
        attrs: {
          columns: _vm.columns,
          data: _vm.enrichedRows,
          "row-key": "id",
          "show-column-add": true,
          resizable: true,
          "sortable-columns": true,
          "local-storage-key": _vm.tableId,
        },
        on: { "row-click": _vm.onRowClick },
        scopedSlots: _vm._u([
          {
            key: "cell-thumbnail",
            fn: function (ref) {
              var row = ref.row
              return [
                row.creative && row.creative.thumbnail_url
                  ? _c("img", {
                      staticClass: "mi-thumb",
                      attrs: {
                        src: row.creative.thumbnail_url,
                        alt: "creative",
                      },
                    })
                  : _c("div", { staticClass: "mi-thumb placeholder" }),
              ]
            },
          },
          {
            key: "cell-name",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("span", { staticClass: "row-name" }, [
                  _vm._v(_vm._s(row.name || row.id)),
                ]),
              ]
            },
          },
          {
            key: "cell-status",
            fn: function (ref) {
              var row = ref.row
              return [
                _vm.getStatusValue(row)
                  ? _c(
                      "span",
                      {
                        staticClass: "mi-status-badge",
                        class: String(_vm.getStatusValue(row)).toLowerCase(),
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.getStatusLabel(row)) +
                            "\n            "
                        ),
                      ]
                    )
                  : _c("span", [_vm._v("-")]),
              ]
            },
          },
          {
            key: "cell-spend",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatCurrency(row._ins.spend)))]
            },
          },
          {
            key: "cell-impressions",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatNumber(row._ins.impressions)))]
            },
          },
          {
            key: "cell-reach",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatNumber(row._ins.reach)))]
            },
          },
          {
            key: "cell-clicks",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatNumber(row._ins.clicks)))]
            },
          },
          {
            key: "cell-ctr",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatPercent(row._ins.ctr)))]
            },
          },
          {
            key: "cell-cpm",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatCurrency(row._ins.cpm)))]
            },
          },
          {
            key: "cell-cpc",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatCurrency(row._ins.cpc)))]
            },
          },
          {
            key: "cell-frequency",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatNumber(row._ins.frequency)))]
            },
          },
          {
            key: "cell-linkClicks",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatNumber(row._ins.linkClicks)))]
            },
          },
          {
            key: "cell-costPerLinkClick",
            fn: function (ref) {
              var row = ref.row
              return [
                _vm._v(_vm._s(_vm.formatCurrency(row._ins.costPerLinkClick))),
              ]
            },
          },
          {
            key: "cell-leads",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatNumber(row._ins.leads)))]
            },
          },
          {
            key: "cell-costPerLead",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatCurrency(row._ins.costPerLead)))]
            },
          },
          {
            key: "cell-pageEngagement",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatNumber(row._ins.pageEngagement)))]
            },
          },
          {
            key: "cell-postEngagement",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatNumber(row._ins.postEngagement)))]
            },
          },
          {
            key: "cell-videoViews",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatNumber(row._ins.videoViews)))]
            },
          },
          {
            key: "cell-reactions",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatNumber(row._ins.reactions)))]
            },
          },
          {
            key: "cell-comments",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatNumber(row._ins.comments)))]
            },
          },
          {
            key: "cell-shares",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v(_vm._s(_vm.formatNumber(row._ins.shares)))]
            },
          },
          {
            key: "cell-messagingStarted",
            fn: function (ref) {
              var row = ref.row
              return [
                _vm._v(_vm._s(_vm.formatNumber(row._ins.messagingStarted))),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }